import './Pages/Login';
import Login from './Pages/Login';
import Home from './Pages/Home';
import Account from './Pages/Account';
import Payment from './Pages/Payment';
import Resources from './Pages/Resources';
import ResourceSurvey from './Pages/ResourceSurvey';
import Landing from './Pages/Landing';
import NewAccount from './Pages/NewAccount';
import ForgotPassword from './Pages/ForgotPassword';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AuthProvider from "./Components/auth/AuthProvider";
import PrivateRoute from "./Components/auth/PrivateRoute";
import Confirmation from './Pages/Confirmation';
import BasicInformation from './Pages/BasicInformation';
import AcademicForm from './Pages/AcademicForm';
import LoanInformation from './Pages/LoanInformation';
import ReviewApplication from './Pages/ReviewApplication';
import { FormDataProvider } from './Pages/FormDataContext';
import { IdDataProvider } from './Pages/IdDataContext';
import { BusinessSurveyProvider } from "./Pages/BusinessSurveyContext";
import SignUp from './Pages/SignUp';
import SurveyContainer from './Pages/SurveyContainer';

import UploadInvoice from './Pages/UploadInvoice'
import InvoiceSuccess from './Pages/InvoiceSuccess'
import HomeUploadInvoice from './Pages/HomeUploadInvoice';
import HomeInvoiceSuccess from './Pages/HomeInvoiceSuccess';
import BusinessSurveyOne from './Pages/BusinessSurvey1';
import BusinessAppStart from './Pages/BusinessAppStart';
import BusinessSurveyIndustrySelection from './Pages/BusinessSurveyIndustrySelection';
import SurveyEnd from './Pages/surveyEnd';
import BusinessInformation from './Pages/BusinessInformation';
import BusinessSurveyLoanInfo from './Pages/BusinessSurveyLoanInfo';
import BusinessSurveyLoanInfo2 from './Pages/BusinessSurveyLoanInfo2';
import WaveLandingPage from './Pages/WaveLandingPage';

import ResumeResources from './Pages/ResumeResources';
import ResumeResourcePage2 from './Pages/ResumeResourcePage2';
import ResumeResourcePage3 from './Pages/ResumeResourcePage3';
import ResumeResourcePage4
 from './Pages/ResumeResourcePage4';

import FAQ from './Pages/FAQ';

 function App() {
  return (
    <div className="App">
      <ChakraProvider>
        <Router>
          <AuthProvider>
            <IdDataProvider>
              <Routes>
                <Route exact path="/" element={<FormDataProvider><Landing /> </FormDataProvider>} />
                <Route path="/login" element={<Login />} />
                <Route path="/forgotpassword" element={<ForgotPassword />} />
                <Route path="/signup" element={<FormDataProvider><SignUp /></FormDataProvider>} />
                <Route path="/info" element={<FormDataProvider><NewAccount /></FormDataProvider>} />
                <Route path="/application-received" element={<FormDataProvider><Confirmation /></FormDataProvider>} />


                <Route path="/basic-information" element={<FormDataProvider><BasicInformation /></FormDataProvider>} />
                <Route path="/academic-information" element={<FormDataProvider><AcademicForm /></FormDataProvider>} />
                <Route path="/loan-information" element={<FormDataProvider><LoanInformation /></FormDataProvider>} />
                <Route path="/review-application" element={<FormDataProvider><ReviewApplication /></FormDataProvider>} />

                <Route path="/upload-invoice" element={<FormDataProvider><UploadInvoice /></FormDataProvider>} />
                <Route path="/invoice-success" element={<FormDataProvider><InvoiceSuccess /></FormDataProvider>} />

                <Route path="/home-upload-invoice" element={<FormDataProvider><HomeUploadInvoice /></FormDataProvider>} />
                <Route path="/home-invoice-success" element={<FormDataProvider><HomeInvoiceSuccess /></FormDataProvider>} />

                <Route element={<PrivateRoute />}>
                  <Route path="/home" element={<Home />} />
                </Route>

                <Route element={<PrivateRoute />}>
                  <Route path="/account" element={<Account />} />
                </Route>

                <Route element={<PrivateRoute />}>
                  <Route path="/payment" element={<Payment />} />
                </Route>

                <Route element={<PrivateRoute />}>
                  <Route path="/resources" element={<Resources />} />
                </Route>
                <Route element={<PrivateRoute />}>
                  <Route path="/resume-resources" element={<ResumeResources/>} />
                </Route>
                <Route element = {<PrivateRoute/>}>
                  <Route path = '/resume-resource-page-2' element ={<ResumeResourcePage2/>} />
                  <Route path = '/resume-resource-page-3' element ={<ResumeResourcePage3/>} />
                  <Route path = '/resume-resource-page-4' element ={<ResumeResourcePage4/>} />
                </Route>

                <Route element={<PrivateRoute />}>
                  <Route path="/faq" element={<FAQ/>} />
                </Route>
                
                <Route element={<PrivateRoute />}>
                  <Route path="/waveLandingPage" element={<WaveLandingPage />} />
                </Route>
                <Route element={<PrivateRoute />}>
                  <Route
                    path="/*"
                    element={
                      <BusinessSurveyProvider>
                        <Routes>
                          <Route path="/small_business_app" element={<BusinessAppStart />} />
                          <Route path="/business-app-1" element={<BusinessSurveyOne />} />
                          <Route path="/business-app-2" element={<BusinessSurveyIndustrySelection />} />
                          <Route path="/business-app-3" element={<BusinessInformation />} />
                          <Route path="/business-app-4" element={<BusinessSurveyLoanInfo />} />
                          <Route path="/business-app-5" element={<BusinessSurveyLoanInfo2 />} />
                          <Route path="/business-survey-end" element={<SurveyEnd />} />
                        </Routes>
                      </BusinessSurveyProvider>
                    }
                  />
                </Route>
              </Routes>
              <SurveyContainer/>
            </IdDataProvider>
          </AuthProvider>
        </Router>
        <Router>

        </Router>
      </ChakraProvider>
    </div>
  );
}

export default App;